/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import { Document, Page, Image, View } from '@react-pdf/renderer';
import { styles } from './styles';
import { AttestationRCVP } from './index';
import { AssurranceRCVP } from './assuranceWeb';

export const CpCgRCVP = (props: any) => {
    const {detailContrat} = props; 
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                    <Image
                        src={require('../../../../ressources/images/deco_pdf.png')}
                        style={styles.image}
                    />
                    <View style={styles.containerBlock}>
                        <AttestationRCVP detailContrat={detailContrat} />
                    </View>

            </Page>
            {
             //CP rcvp
            }
            <Page size="A4" style={styles.page}>
                <View style={styles.containerBlock}>
                    <AssurranceRCVP detailContrat={detailContrat} />
                </View>

            </Page>
            <Page size="A4" >
                <Image
                    src={require('../../../../ressources/cgCp/Rcvp/cp/CP_RCVP-2.png')}
                    style={styles.image}
                />
            </Page>
            <Page size="A4" >
                <Image
                    src={require('../../../../ressources/cgCp/Rcvp/cp/CP_RCVP-3.png')}
                    style={styles.image}
                />
            </Page>
            {
             //cg rcvp
            }
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-1.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-2.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-3.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-4.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-5.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-6.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-7.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Rcvp/cg/CG_RCVP-8.png')} style={styles.image}/>
            </Page>
        </Document>
    );
}